export enum StepperOrientation {
    Vertical,
    Horizontal
}
